import styles from "./Text.module.scss"

export const Text = ({ children, bold, title }) => {
    return <div className={styles.text} style={{ fontWeight: bold ? 600 : null, fontSize: title ? 28 : null }}>{children}</div >
}